import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from '../locales/en.json';
import thTranslations from '../locales/th.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      th: { translation: thTranslations },
    },
    // Default to Thai for first-time visitors. Returning visitors get
    // whatever they previously selected via the LanguageSwitcher.
    fallbackLng: 'th',
    supportedLngs: ['en', 'th'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Only honor an explicit user choice from localStorage. Skip
      // navigator detection so an English-locale browser still lands
      // on Thai by default.
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  });

export default i18n;
